import React from 'react';
import { TweenLite } from 'gsap';
import $ from 'jquery';

class MouseMove extends React.Component {
  componentDidMount() {
    const outerCursor = document.querySelector('.cursor .outer');
    const innerCursor = document.querySelector('.cursor .inner');
    const backCursor = document.querySelector('.cursor .back');

    let x = document.body.offsetWidth / 2;
    let y = window.innerHeight / 2;

    TweenLite.set(outerCursor, {
      opacity: 0,
    });

    TweenLite.set(innerCursor, {
      opacity: 0,
    });

    TweenLite.set(backCursor, {
      opacity: 0,
    });

    document.body.addEventListener('mouseenter', (e) => {
      x = e.clientX;
      y = e.clientY;

      TweenLite.set(outerCursor, {
        x: x - outerCursor.offsetWidth / 2,
        y: y - outerCursor.offsetHeight / 2,
      });

      TweenLite.set(innerCursor, {
        x: x - innerCursor.offsetWidth / 2,
        y: y - innerCursor.offsetHeight / 2,
      });

      TweenLite.set(backCursor, {
        x: x - backCursor.offsetWidth / 2,
        y: y - backCursor.offsetHeight / 2,
      });

      TweenLite.to(outerCursor, 0.3, {
        opacity: 1,
      });

      TweenLite.to(innerCursor, 0.3, {
        opacity: 1,
      });

      TweenLite.to(backCursor, 0.3, {
        opacity: 1,
      });
    });

    window.addEventListener('mousemove', (e) => {
      x = e.clientX;
      y = e.clientY;

      innerCursor.style.transform = `translate(${x -
        innerCursor.offsetWidth / 2}px, ${y - innerCursor.offsetHeight / 2}px)`;

      /*outerCursor.style.transform = `translate(${x - outerCursor.offsetWidth/2}px, ${y-outerCursor.offsetHeight/2}px)`;

  backCursor.style.transform = `translate(${x - backCursor.offsetWidth/2}px, ${y-backCursor.offsetHeight/2}px)`;*/

      /*TweenLite.to(innerCursor, 0.1, {
    x: x - innerCursor.offsetWidth/2,
    y: y - innerCursor.offsetHeight/2
  });  */

      TweenLite.to(outerCursor, 0.2, {
        x: x - outerCursor.offsetWidth / 2,
        y: y - outerCursor.offsetHeight / 2,
      });
      TweenLite.to(backCursor, 0.4, {
        x: x - backCursor.offsetWidth / 2,
        y: y - backCursor.offsetHeight / 2,
      });
    });

    $('a').hover(
      function() {
        $('.cursor.back').addClass('backcursor--hover');
        $('.cursor.front').addClass('cursor--hover');
      },
      function() {
        $('.cursor.back').removeClass('backcursor--hover');
        $('.cursor.front').removeClass('cursor--hover');
      }
    );
  }
  render() {
    return (
      <>
        <div className="cursor back">
          <div className="back">
            <div className="border"></div>
          </div>
        </div>
        <div className="cursor front">
          <div className="inner"></div>
          <div className="outer">
            <div className="border"></div>
          </div>
        </div>
      </>
    );
  }
}

export default MouseMove;
